(function () {
  var MQ = '(max-width: 989px)';

  function isMobile() {
    return window.matchMedia(MQ).matches;
  }

  function getGallerySlider() {
    return document.querySelector(
      '.template-product [id^="Slider-Gallery-"], .ci-page-product [id^="Slider-Gallery-"]'
    );
  }

  function getGalleryWrapper() {
    return document.querySelector(
      '.template-product .product__media-wrapper, .ci-page-product .product__media-wrapper'
    );
  }

  function getHeaderOffset() {
    var value = getComputedStyle(document.documentElement).getPropertyValue('--ci-pdp-header-offset');
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : 88;
  }

  function syncSliderToActiveSlide(slider) {
    if (!slider) return;
    var slides = slider.querySelectorAll('.product__media-item');
    if (!slides.length) return;

    var active = slider.querySelector('.product__media-item.is-active') || slides[0];
    var index = Math.max(0, Array.prototype.indexOf.call(slides, active));
    var width = slider.clientWidth || 1;
    slider.scrollLeft = index * width;
  }

  function restoreMobileGalleryAfterZoom() {
    if (!isMobile()) return;

    var wrapper = getGalleryWrapper();
    var slider = getGallerySlider();

    syncSliderToActiveSlide(slider);

    if (wrapper) {
      wrapper.scrollTop = 0;
      var top = wrapper.getBoundingClientRect().top + window.scrollY - getHeaderOffset();
      window.scrollTo(0, Math.max(0, top));
    }

    document.dispatchEvent(new CustomEvent('ci:pdp-gallery:restore'));
  }

  function ensureMobileCloseBar(modal) {
    if (!modal || modal.querySelector('.ci-pdp-modal-close-bar')) return;

    var dialog = modal.querySelector('.product-media-modal__dialog');
    if (!dialog) return;

    var bar = document.createElement('button');
    bar.type = 'button';
    bar.className = 'ci-pdp-modal-close-bar';
    bar.setAttribute('aria-label', 'Cerrar vista ampliada');
    bar.textContent = 'Cerrar';
    bar.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      modal.hide();
    });
    dialog.appendChild(bar);
  }

  function bindMobileBackdropClose(modal) {
    if (!modal || modal.dataset.ciBackdropCloseBound === 'true') return;

    var dialog = modal.querySelector('.product-media-modal__dialog');
    var content = modal.querySelector('[role="document"]');
    if (!dialog) return;

    function shouldClose(event) {
      if (!isMobile() || !modal.hasAttribute('open')) return false;
      if (event.target.closest('.product-media-modal__toggle, .ci-pdp-modal-close-bar')) return false;
      if (event.target === dialog || event.target === modal) return true;
      if (content && event.target === content) return true;
      return false;
    }

    function onBackdrop(event) {
      if (!shouldClose(event)) return;
      event.preventDefault();
      modal.hide();
    }

    dialog.addEventListener('click', onBackdrop);
    dialog.addEventListener('touchend', onBackdrop, { passive: false });
    modal.dataset.ciBackdropCloseBound = 'true';
  }

  function patchProductModal() {
    var ModalClass = customElements.get('product-modal');
    if (!ModalClass || ModalClass._ciPdpMobilePatched) return;

    var originalShow = ModalClass.prototype.show;
    var originalShowActiveMedia = ModalClass.prototype.showActiveMedia;
    var originalHide = ModalClass.prototype.hide;

    document.querySelectorAll('product-modal.product-media-modal').forEach(function (modal) {
      ensureMobileCloseBar(modal);
      bindMobileBackdropClose(modal);
    });

    ModalClass.prototype.show = function (opener) {
      if (isMobile()) {
        this._ciSavedScrollY = window.scrollY;
        ensureMobileCloseBar(this);
        bindMobileBackdropClose(this);
      }
      originalShow.call(this, opener);

      if (isMobile() && typeof this._ciSavedScrollY === 'number') {
        window.scrollTo(0, this._ciSavedScrollY);
      }
    };

    ModalClass.prototype.showActiveMedia = function () {
      originalShowActiveMedia.call(this);

      if (!isMobile()) return;

      if (typeof this._ciSavedScrollY === 'number') {
        window.scrollTo(0, this._ciSavedScrollY);
      }

      var container = this.querySelector('[role="document"]');
      if (container) {
        container.scrollTop = 0;
        container.scrollLeft = 0;
      }
    };

    ModalClass.prototype.hide = function () {
      var container = this.querySelector('[role="document"]');
      if (container) {
        container.scrollTop = 0;
        container.scrollLeft = 0;
      }

      originalHide.call(this);

      if (!isMobile()) return;

      requestAnimationFrame(function () {
        requestAnimationFrame(restoreMobileGalleryAfterZoom);
      });
    };

    ModalClass._ciPdpMobilePatched = true;
  }

  function initGalleryProgress() {
    var root = document.querySelector('.template-product, .ci-page-product');
    if (!root) return;

    root.querySelectorAll('[data-ci-pdp-gallery-progress]').forEach(function (progress) {
      if (progress.dataset.ciPdpProgressReady === 'true') return;

      var sectionId = progress.dataset.sectionId;
      var slider = document.getElementById('Slider-Gallery-' + sectionId);
      if (!slider) return;

      var slides = slider.querySelectorAll('.product__media-item');
      if (slides.length < 2) {
        progress.hidden = true;
        return;
      }

      var track = progress.querySelector('.ci-pdp-gallery-progress__track');
      if (!track) return;

      track.innerHTML = '';
      slides.forEach(function (_, index) {
        var seg = document.createElement('span');
        seg.className = 'ci-pdp-gallery-progress__seg' + (index === 0 ? ' is-active' : '');
        track.appendChild(seg);
      });

      var segments = track.querySelectorAll('.ci-pdp-gallery-progress__seg');

      function setActive(index) {
        var i = Math.max(0, Math.min(index, segments.length - 1));
        segments.forEach(function (seg, idx) {
          seg.classList.toggle('is-active', idx === i);
        });
      }

      function onScroll() {
        var width = slider.clientWidth;
        if (!width) return;
        setActive(Math.round(slider.scrollLeft / width));
      }

      slider.addEventListener('scroll', onScroll, { passive: true });

      var viewer = document.getElementById('GalleryViewer-' + sectionId);
      if (viewer) {
        viewer.addEventListener('slideChanged', function (event) {
          var current = event.detail && event.detail.currentElement;
          if (!current) return;
          var index = Array.prototype.indexOf.call(slides, current);
          if (index >= 0) setActive(index);
        });
      }

      document.addEventListener('ci:pdp-gallery:restore', onScroll);

      progress.dataset.ciPdpProgressReady = 'true';
      progress.hidden = !isMobile();
    });
  }

  function onResize() {
    var mobile = isMobile();
    document.querySelectorAll('[data-ci-pdp-gallery-progress]').forEach(function (progress) {
      progress.hidden = !mobile || progress.querySelectorAll('.ci-pdp-gallery-progress__seg').length < 2;
    });
  }

  function ensureModalPatch() {
    if (customElements.get('product-modal')) {
      patchProductModal();
      return;
    }
    customElements.whenDefined('product-modal').then(patchProductModal);
  }

  function init() {
    ensureModalPatch();
    initGalleryProgress();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('product-info:loaded', init);
  window.addEventListener('resize', onResize, { passive: true });
})();
